<template>
  <div class="search-app__cards-container">
    <h3 class="search-app__cards-title">
      Trending Products
    </h3>
    <div class="search-app__cards">
      <productItem
        v-for="(product, index) in trendingProducts"
        :key="product.id"
        :product="product"
        :index="index"
      />
    </div>
    <div
      v-if="viewAnchor"
      class="container"
    >
      <div class="row">
        <div class="col-md-12 text-center">
          <div class="view-all-items">
            <a
              :href="viewAllProductsAnchor"
              class="view_all search-app__cards-title"
            >
              View All Products
            </a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import productItem from '~legacy-vue/vueComponents/SearchModal/productItem.vue'
export default {

  name: 'SearchTrendingCard',

  components: {
    productItem,
  },
  props: {
    trendingProducts: Array,
    searchTerm_: String,
  },

  data() {
    return {
      viewAllProductsAnchor: '',
      viewAnchor: false,
    }
  },

  computed: {

    hasTrendingProductsItems() {
      if(this.trendingProducts){
        return this.trendingProducts.length > 0
      }
    },

  },

  watch: {
    searchTerm_: {
      deep: true,
      handler: function (newValue, oldValue) {
        this.viewAllProductsAnchor = this.generateViewAllProductLink(newValue)
        this.viewAnchor = this.isViewAllProductsVisible()
      },
    },
  },

  mounted() {
    this.viewAnchor = this.isViewAllProductsVisible()
    window.addEventListener('resize', ()=> {
      this.viewAnchor = this.isViewAllProductsVisible()
    })
  },

  methods: {
    generateViewAllProductLink(term) {
      if(this.isViewAllProductsVisible) {
        return `/search?q=${term}`
      }
    },

    isMobile() {
      return (window.innerWidth <= 768)? true: false
    },

    isViewAllProductsVisible() {
      if (!this.searchTerm_) {
        return
      }

      return this.searchTerm_ != 'defaultsearch' && this.searchTerm_.length >= 3 != '' && this.hasTrendingProductsItems && !this.isMobile()
    },
  },
}
</script>
<style lang="scss">

  .view-all-items {
    display: flex;
    justify-content: center;
  }

  .view-all-items a {
    display: flex;
    align-items: center;
    margin: 10px;
    color: #000;
    padding-bottom: 0;
    border: 0;
    font-weight: 600;
  }

  .view-all-items a:hover {
    color: #000;
  }

</style>
